import React from 'react';

interface IProps {
  style?: object,
  children: React.ReactNode,
}

const HeaderWrapper = ({ style, children }: IProps) => (
  <thead style={ style }>
    { children }
  </thead>
);

export default HeaderWrapper;
